import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ChooseLocationFacade } from './+state';
import { ChooseLocationStateModule } from './+state/choose-location.state.module';

import {
  ChooseLocationService
} from './services';

@NgModule({
  imports: [CommonModule, ChooseLocationStateModule],
})
export class DomainChooseLocationModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainChooseLocationModule,
      providers: [
        ChooseLocationService,
        ChooseLocationFacade
      ],
    };
  }
}
